// The floating "ghost" rendered under the cursor for the whole drag (dnd-kit's
// DragOverlay), used for item/todo rows. Without it, the dragged row's own node just
// fades in place inside its origin category's SortableContext — once the drag crosses
// into another category, that row visually disappears behind the destination category's
// own opaque card background, so there's nothing following the cursor to look at.
import type { ReactNode } from "react";
import { vars } from "@pack-it-up/ui-web";
import { DragHandleIcon } from "../../app/icons.js";

export const DragPreview = ({ name }: { name: string }): ReactNode => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "9px 14px",
      background: vars.color.surfaceRaised,
      border: `1px solid ${vars.color.border}`,
      borderRadius: vars.radius.md,
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
      fontSize: vars.font.sizeSm,
      color: vars.color.text,
      cursor: "grabbing",
      maxWidth: "320px",
    }}
  >
    <span aria-hidden style={{ color: vars.color.textMuted, flexShrink: 0, display: "inline-flex" }}>
      {DragHandleIcon}
    </span>
    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
  </div>
);
